import { render, staticRenderFns } from "./PermissionsIndex.vue?vue&type=template&id=2a61d569&"
import script from "./PermissionsIndex.vue?vue&type=script&lang=js&"
export * from "./PermissionsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports